import React from 'react';
import { Row, Col, Button, UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { colors } from 'app/config/color';
import { Link } from 'react-router-dom';
import FederatedInfoDetail from './federated-info-detail';
import FederatedAddModel from './federated-add-modal';
import { IRootState } from 'app/shared/reducers';
import { getInfoMapping } from 'app/modules/account/user/user.reducer';
import { connect } from 'react-redux';
import moment from 'moment';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IFederatedInfoProps extends StateProps, DispatchProps {
  infoMapping: any;
}

export interface IFederatedInfoState {
  showModalDetail: boolean;
  showModalAdd: boolean;
  infoMapping: any;
}

export class FederatedInfo extends React.Component<IFederatedInfoProps, IFederatedInfoState> {
  state: IFederatedInfoState = {
    showModalDetail: false,
    showModalAdd: false,
    infoMapping: {}
  };

  toggleDetail = e => {
    e.preventDefault();
    this.setState(prevState => ({
      showModalDetail: !prevState.showModalDetail
    }));
  };

  toggleAdd = e => {
    e.preventDefault();
    this.setState(prevState => ({
      showModalAdd: !prevState.showModalAdd
    }));
  };

  renderRowFederated = (label, value) => {
    return (
      <Row>
        <Col md={3}>
          <label>{label}</label>
        </Col>
        <Col md={7}>
          <label className="font-weight-bold">{value ? value : '----------'}</label>
        </Col>
        <Col md={2} className="text-center">
          <Link id="testTooltip" to="/">
            <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />
          </Link>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <div className="col-md-12 col-sm-12 col-centered borderStyle" style={{ marginTop: '20px' }}>
        <FederatedInfoDetail modalShow={this.state.showModalDetail} handleClose={this.toggleDetail} />
        <FederatedAddModel modalShow={this.state.showModalAdd} handleClose={this.toggleAdd} />

        <h4 className="font-weight-bold">Danh sách tài khoản liên kết</h4>
        <hr />

        <Row style={{ flex: 1 }}>
          <Col style={{ flex: 0.1 }}>
            {/* <FontAwesomeIcon icon={faUserCircle} size="5x" color={colors.iconUser} /> */}
            <img src={require('../../../../images/avatar_icon.png')} alt="" />
          </Col>
          <Col style={{ flex: 0.7 }}>
            <div>
              <p className="font-weight-bold">Tài khoản liên kết: {this.props.infoMapping.account}</p>
              <p>Tài khoản định danh điện tử cấp bởi Bộ Công an</p>
              <p>Ngày liên kết: {moment(this.props.infoMapping.createdDate).format(APP_LOCAL_DATE_FORMAT)}</p>
            </div>
          </Col>
        </Row>

        {/*<Row>*/}
        {/*  <div className="col-md-4 col-sm-4 borderStyle maxWidthFed">*/}
        {/*    <h5 className="text-center font-weight-bold" style={{ color: '#1a6dca' }}>*/}
        {/*      Thông tin tài khoản*/}
        {/*    </h5>*/}
        {/*    <p className="text-center">123456789</p>*/}
        {/*    {this.renderRowFederated('Họ tên', 'Nguyễn Đăng Đông')}*/}
        {/*    {this.renderRowFederated('Số CMT', '123456789')}*/}
        {/*    {this.renderRowFederated('Ngày sinh', '21/07/1994')}*/}
        {/*    {this.renderRowFederated('Giới tính', 'Nam')}*/}
        {/*    {this.renderRowFederated('Nơi sinh', 'Hà đông - hà nội')}*/}
        {/*    <div className="flexEnd">*/}
        {/*      <Link id="linkStyle" to="/" onClick={e => this.toggleDetail(e)}>*/}
        {/*        Xem chi tiết*/}
        {/*      </Link>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div className="col-md-4 col-sx-4 addInfo maxWidthFed">*/}
        {/*    <div className="contentCenter" style={{ margin: '20px 0' }}>*/}
        {/*      <Button id="btnAdd" onClick={this.toggleAdd}>*/}
        {/*        <FontAwesomeIcon icon={faPlusCircle} size="5x" color="#1a62b3" />*/}
        {/*      </Button>*/}
        {/*    </div>*/}

        {/*    <h5 className="text-center font-weight-bold" style={{ color: '#1a6dca' }}>*/}
        {/*      Thêm mã số cá nhân*/}
        {/*    </h5>*/}
        {/*    <p className="text-center">(mã số thuế, mã bảo hiểm xã hội, ...)</p>*/}
        {/*    <div className="flexEnd">*/}
        {/*      <Link id="linkStyle" to="/" onClick={e => this.toggleAdd(e)}>*/}
        {/*        Cập nhật thông tin*/}
        {/*      </Link>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</Row>*/}
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({});
const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FederatedInfo);
